import { DimensionUnit } from '../../../enums/dimension-unit';

export const isCentimeters = (unit) => {
  const lowercaseUnit = unit?.toLowerCase();

  return (
    lowercaseUnit === DimensionUnit.Centimeters.toLowerCase() ||
    lowercaseUnit === DimensionUnit.Centimeter.toLowerCase() ||
    lowercaseUnit === 'cm'
  );
};
